var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',{staticClass:"footer-text d-flex justify-content-center"},[_vm._v("Muhammad Valensyah Alfansyuri© 2020")])])}]

export { render, staticRenderFns }